import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { peutGererSignatures } from '../../lib/messagerie/droits';
import Messagerie from './Messagerie';
import SignaturesMail from './SignaturesMail';
import './Messagerie.css';

/**
 * L'onglet « Mails » de l'administration : la messagerie du support et, pour le
 * super-administrateur, les signatures.
 *
 * `demande` change à chaque arrivée par `/admin?onglet=mails` (notification,
 * bouton des mails) — même vers une adresse identique : on revient alors sur la
 * messagerie, calée sous la barre du site.
 */
export default function OngletMails({ demande = null }) {
  const user = useSelector((s) => s.auth.user);
  const gereSignatures = peutGererSignatures(user);
  const [sousOnglet, setSousOnglet] = useState('messagerie');
  const ancre = useRef(null);

  useEffect(() => {
    if (!demande) return undefined;
    setSousOnglet('messagerie');

    // On attend que l'onglet soit peint, puis on le cale sous la barre du site
    // (collante, elle le cacherait).
    const image = window.requestAnimationFrame(() => {
      const cible = ancre.current;
      if (!cible) return;
      const barre = document.querySelector('.sticky-header')?.getBoundingClientRect().height ?? 0;
      const doux = !window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
      window.scrollTo({
        top: Math.max(0, cible.getBoundingClientRect().top + window.scrollY - barre - 12),
        behavior: doux ? 'smooth' : 'auto',
      });
    });
    return () => window.cancelAnimationFrame(image);
  }, [demande]);

  const onglets = [
    { cle: 'messagerie', libelle: 'Messagerie' },
    ...(gereSignatures ? [{ cle: 'signatures', libelle: 'Signatures' }] : []),
  ];

  return (
    <div className="onglet-mails" ref={ancre}>
      <div className="tab-buttons" style={{ marginBottom: '1.5rem' }} role="tablist" aria-label="Mails">
        {onglets.map((o) => (
          <button
            key={o.cle}
            type="button"
            role="tab"
            aria-selected={sousOnglet === o.cle}
            className={`btn ${sousOnglet === o.cle ? 'btn-primary' : 'btn-outline'}`}
            onClick={() => setSousOnglet(o.cle)}
          >
            {o.libelle}
          </button>
        ))}
      </div>

      {sousOnglet === 'messagerie' && <Messagerie />}
      {sousOnglet === 'signatures' && gereSignatures && <SignaturesMail />}
    </div>
  );
}
